import type { Components, Theme } from '@mui/material/styles';

export const dividerTheme: Components<Theme>['MuiDivider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.vars.palette.semantic.divider.primary,
      '&::before, &::after': {
        borderTopColor: theme.vars.palette.semantic.divider.primary
      }
    })
  }
};
